module.exports = __webpack_public_path__ + "static/media/snow-white.dee54193.svg";